import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 65vw;
	min-width: 350px;
	max-width: 980px;
	overflow-x: hidden;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;

	@media (max-width: 538px) {
		width: calc(100vw - 3rem);
		min-width: 0;
		max-width: 100%;
		gap: 1rem;
	}
`;

export const content = styled.div`
	width: 100%;
	max-height: 70vh;
	overflow-y: auto;
	overflow-x: hidden;
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 32rem);
	gap: 2rem;
	align-items: start;

	@media (max-width: 1000px) {
		grid-template-columns: minmax(0, 1fr);
	}

	@media (max-width: 538px) {
		max-height: 68vh;
		gap: 1.4rem;
		padding-right: 0.2rem;
	}
`;

export const contentForm = styled.div`
	width: 100%;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding-bottom: 2rem;
`;

export const twoInputs = styled.div`
	width: 100%;
	min-width: 0;
	display: flex;
	align-items: flex-start;
	flex-wrap: wrap;
	gap: 1.5rem;

	> * {
		flex: 1 1 calc(50% - 0.75rem);
		min-width: 0;
	}

	@media (max-width: 800px) {
		> * {
			flex-basis: 100%;
		}
	}

	@media (max-width: 538px) {
		gap: 1rem;
	}
`;

export const sectionTitle = styled.p`
	width: 100%;
	font-size: 1.4rem;
	font-family: nunito-bold;
	color: ${color.interface.darkgray3};
	margin-top: 0.5rem;
`;

export const galleryForm = styled.div`
	width: 100%;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const addImageButton = styled.button`
	all: unset;
	width: 100%;
	padding: 1rem 0;
	border-radius: 5px;
	background-color: ${color.system.info};
	color: ${color.interface.white};
	font-size: 1.3rem;
	font-family: nunito-bold;
	text-align: center;
	cursor: pointer;
`;

export const imageCounter = styled.p`
	font-size: 1.3rem;
	color: ${color.interface.lightGray};
`;

export const registeredImages = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 1rem;

	@media (max-width: 538px) {
		grid-template-columns: minmax(0, 1fr);
	}
`;

export const registeredImage = styled.div`
	width: 100%;
	min-width: 0;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding-bottom: 0.8rem;

	img {
		width: 100%;
		height: 9rem;
		object-fit: cover;
		display: block;
	}

	p {
		padding: 0 0.8rem;
		font-size: 1.2rem;
		color: ${color.interface.lightGray};
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const registeredImageActions = styled.div`
	padding: 0 0.8rem;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 0.8rem;

	button {
		all: unset;
		padding: 0.7rem 0;
		border-radius: 5px;
		background-color: ${color.system.error};
		color: ${color.interface.white};
		font-size: 1.2rem;
		text-align: center;
		cursor: pointer;
	}

	button:first-child {
		background-color: ${color.system.info};
	}
`;

export const preview = styled.div`
	width: 100%;
	min-width: 0;
	max-width: 100%;
	position: sticky;
	top: 0;
	align-self: start;
	display: flex;
	flex-direction: column;
	gap: 1rem;

	@media (max-width: 538px) {
		position: static;
		gap: 0.8rem;
	}
`;

export const previewTitle = styled.p`
	width: 100%;
	font-size: 1.4rem;
	font-family: nunito-bold;
	color: ${color.interface.darkgray3};
`;

export const popupPreview = styled.div<{ $variant: 'COUNTDOWN' | 'SIMPLE' }>`
	width: 100%;
	min-height: ${(props) => (props.$variant === 'SIMPLE' ? '44rem' : '52rem')};
	border-radius: 5px;
	background-color: ${color.interface.darkgray};
	padding: 1.2rem;
	display: flex;
	align-items: center;
	justify-content: center;

	@media (max-width: 538px) {
		min-height: ${(props) => (props.$variant === 'SIMPLE' ? '34rem' : '41rem')};
		padding: 1rem;
	}
`;

export const popupCard = styled.div<{ $variant: 'COUNTDOWN' | 'SIMPLE' }>`
	position: relative;
	width: ${(props) => (props.$variant === 'SIMPLE' ? '30rem' : '31rem')};
	max-width: 100%;
	overflow: hidden;
	border-radius: ${(props) => (props.$variant === 'SIMPLE' ? '12px' : '10px')};
	background: ${(props) =>
		props.$variant === 'SIMPLE'
			? color.interface.white
			: 'linear-gradient(180deg, #7b3fa0 0%, #4b1975 100%)'};
	box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.22);
	padding: ${(props) => (props.$variant === 'SIMPLE' ? '1.6rem' : '1.8rem')};

	@media (max-width: 538px) {
		width: 100%;
		padding: ${(props) => (props.$variant === 'SIMPLE' ? '1.2rem' : '1.4rem')};
	}
`;

export const previewClose = styled.span`
	position: absolute;
	top: 1rem;
	right: 1.4rem;
	z-index: 2;
	font-size: 2.4rem;
	line-height: 1;
	color: ${color.interface.lightGray};
`;

export const simpleTitle = styled.h2`
	width: 100%;
	margin-bottom: 1.2rem;
	padding-right: 2rem;
	text-align: center;
	font-size: 2.8rem;
	font-family: nunito-bold;
	color: #5c2884;

	@media (max-width: 538px) {
		margin-bottom: 1rem;
		font-size: 2rem;
		line-height: 1.2;
	}
`;

export const countdownTitle = styled.h2`
	width: 100%;
	margin-bottom: 1.4rem;
	padding-right: 2rem;
	font-size: 3.4rem;
	font-family: nunito-bold;
	color: #f5a313;

	@media (max-width: 538px) {
		margin-bottom: 1rem;
		font-size: 2.4rem;
		line-height: 1.15;
	}
`;

export const previewImage = styled.div<{ $variant: 'COUNTDOWN' | 'SIMPLE' }>`
	width: 100%;
	height: ${(props) => (props.$variant === 'SIMPLE' ? '28rem' : '19rem')};
	background-color: ${color.interface.lightGray4};
	border-radius: 6px;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	@media (max-width: 538px) {
		height: ${(props) => (props.$variant === 'SIMPLE' ? '20rem' : '15rem')};
	}
`;

export const previewCarousel = styled.div`
	width: 100%;
	height: 27rem;
	overflow: hidden;

	> div {
		height: 100%;
	}

	img {
		border-radius: 14px;
	}

	[data-testid='balls0'] {
		position: absolute;
		bottom: 1.2rem;
		left: 0;
		gap: 0.4rem;
		padding: 0;
	}

	[data-testid='balls0'] > div {
		min-width: 6px;
		min-height: 6px;
		background-color: ${color.interface.white};
	}

	@media (max-width: 538px) {
		height: 20rem;
	}
`;

export const previewText = styled.div<{ $variant: 'COUNTDOWN' | 'SIMPLE' }>`
	width: 100%;
	padding: ${(props) =>
		props.$variant === 'SIMPLE' ? '1.6rem 0 0' : '1.6rem 0 0'};
	display: flex;
	flex-direction: column;
	gap: ${(props) => (props.$variant === 'SIMPLE' ? '1.4rem' : '1rem')};
	align-items: center;

	h3 {
		width: 100%;
		font-size: ${(props) =>
			props.$variant === 'SIMPLE' ? '1.4rem' : '1.7rem'};
		line-height: 1.45;
		text-align: center;
		color: ${(props) =>
			props.$variant === 'SIMPLE'
				? color.interface.darkgray3
				: color.interface.white};
		font-family: nunito-bold;
		font-style: ${(props) =>
			props.$variant === 'SIMPLE' ? 'normal' : 'italic'};
	}

	p {
		font-size: 1.2rem;
		line-height: 1.5;
		color: ${color.interface.lightGray};
	}

	@media (max-width: 538px) {
		gap: ${(props) => (props.$variant === 'SIMPLE' ? '1rem' : '0.8rem')};

		h3 {
			font-size: ${(props) =>
				props.$variant === 'SIMPLE' ? '1.25rem' : '1.35rem'};
			line-height: 1.35;
		}
	}
`;

export const counter = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 0.5rem;

	span {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.2rem;
		border-radius: 5px;
		text-align: center;
		background-color: transparent;
		font-size: 3rem;
		font-family: nunito-bold;
		color: #f5a313;
		line-height: 1;
	}

	small {
		font-size: 0.9rem;
		color: #f5a313;
	}

	@media (max-width: 538px) {
		gap: 0.4rem;

		span {
			font-size: 2rem;
		}

		small {
			font-size: 0.75rem;
		}
	}
`;

export const cta = styled.button<{ $variant: 'COUNTDOWN' | 'SIMPLE' }>`
	all: unset;
	width: 100%;
	padding: 1rem 0;
	border-radius: 5px;
	background-color: ${(props) =>
		props.$variant === 'SIMPLE' ? '#5c2884' : color.interface.white};
	color: ${(props) =>
		props.$variant === 'SIMPLE' ? color.interface.white : '#5c2884'};
	font-size: 1.3rem;
	font-family: nunito-bold;
	text-align: center;
	cursor: pointer;
`;

export const secondaryCta = styled.p<{ $variant: 'COUNTDOWN' | 'SIMPLE' }>`
	width: 100%;
	text-align: center;
	font-size: 1.2rem;
	line-height: 1.4;
	color: ${(props) =>
		props.$variant === 'SIMPLE'
			? color.interface.lightGray
			: color.interface.white};
`;

export const imageModalContent = styled.div`
	width: min(62rem, 70vw);
	display: flex;
	flex-direction: column;
	gap: 1.5rem;

	@media (max-width: 538px) {
		width: calc(100vw - 3rem);
		gap: 1rem;
	}
`;

export const containerBtns = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;

	button {
		all: unset;
		width: 100%;
		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;
	}

	@media (max-width: 538px) {
		flex-direction: column-reverse;
		gap: 0.8rem;

		button {
			padding: 1rem;
		}
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;
